import React, { useEffect, useState } from "react";
import "../styles/CourseCardPageStyles.css";
import Specialization from "../../recommendation/assets/images/skill-up-page/Specialization.svg";
import AssessmentNotFound from "../../../assets/images/recommandation/assessmentNotFound.png";
import IndustryNotFound from "../../../assets/images/recommandation/industryNotFound.png";
import Beginner from "../../recommendation/assets/images/skill-up-page/Beginner.svg";
import Content from "../../recommendation/assets/images/skill-up-page/Content.svg";
import Schedule from "../../recommendation/assets/images/skill-up-page/Schedule.svg";
import PlayButton from "../../recommendation/assets/images/skill-up-page/PlayButton.svg";
import NewIcon from "../../recommendation/assets/images/New.svg";

import { videolandingPageRequest } from "../data/request/VideoLandingPageRequest";
import {
  Recommendation,
  videoLandingPageResponse,
} from "../data/response/VideoLandingPageResponse";

import { Button, Card, CardBody, CardText, CardTitle } from "reactstrap";
import { useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { handleImageErrorCallBack } from "../../recommendation/recommendation_industry_view/components/ErrorImage_PlaceHolder";
import { CourseNameTitleTextComponent } from "../../recommendation/recommendation_industry_view/components/TopicNameTittleText";
import { logActionEvent } from "../../../analytics/analytics_utils";
import analytics_strings from "../../../analytics/analytics_strings";
import infoImg from "../assets/images/info 1.png";
import GenericModal from "./GenericModelComponent";
import { Col, Container, Row } from "react-bootstrap";
import LearningRoomViewPage from "../pages/LearningRoomViewPage";
import {
  setLRCourseSelectedItem,
  setLRSelectedItem,
  setLRTopicDetailedIndex,
} from "../data/redux/LearningRoomRedux";
import CouresCardChildPage from "./CourseCardChildPage";

interface JozunaSkillUpProps {
  activeTab: number;
  jozunaData: Recommendation[] | null;
  industryData: Recommendation[] | null;
  jozunaDuration: number;
  industryDuration: number;
  program_title?: string;
  program_description?: string;
  jozuna_title?: string;
  jozuna_description?: string;
  jozuna_program_id?: string;
  industry_program_id?: string;
  assessmentFound?: boolean;
  type?: string;
  programDropdownComponent?: React.ReactNode;
}

const CourseCardComponent: React.FC<JozunaSkillUpProps> = ({
  type,
  assessmentFound,
  activeTab,
  jozunaData,
  industryData,
  jozunaDuration,
  industryDuration,
  program_description,
  program_title,
  jozuna_title,
  jozuna_description,
  jozuna_program_id,
  industry_program_id,
  programDropdownComponent,
}) => {
  const active = activeTab;
  const cardData = jozunaData;
  const industry = industryData;
  const dispatch = useDispatch();
  const durationJozuna = jozunaDuration;
  const durationIndustry = industryDuration;
  const [programModelOpen, setProgramModelOpen] = useState(false);
  //Course Card Selections
  const [selectedCourse, setSelectedCourse] = useState<Recommendation | null>(
    null,
  );
  const [selectedItem, setSelectedItem] = useState<Recommendation | null>(null);
  const navigate = useNavigate();
  // Select the data from the Redux store
  const userData = useSelector((state: RootState) => state.profile.profileKeys);
  const handleJozunaDataClick = (data: any) => {
    navigate("/dashboard/recommendation/jozunaview", {
      state: {
        course_id: data.course_id,
        course_name: data.course_title,
        program_id: jozuna_program_id,
      },
    });
  };
  const courseSelectedItem = useSelector(
    (state: RootState) => state.learningRoom.courseSelectedItem,
  );
  useEffect(() => {
    if (courseSelectedItem !== null) {
      setSelectedItem(courseSelectedItem);
    } else {
      setSelectedItem(
        activeTab === 0 ? (cardData?.[0] ?? null) : (industry?.[0] ?? null),
      );
    }
  }, [industry]);
  const handleIndustryDataClick = (data: any) => {
    navigate("/dashboard/learning-room/view-courses", {
      state: {
        course_id: data.course_id,
        course_name: data.course_title,
        program_id: industry_program_id,
        program_description: program_description,
        program_title: program_title,
      },
    });
  };
  return (
    <div className="jozuna-skillup-page">
      <div className="background-image"></div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          position: "sticky",
          top: 0,
          // zIndex: 1000,
          backgroundColor: "#fff",
          paddingBottom: "15px",
        }}
      >
        <div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "15px",
              alignItems: "start",
              justifyContent: "start",
            }}
          >
            <h1 className="video-page-headingv2">
              {active === 0 ? jozuna_title : program_title}
            </h1>
            <div
              className="view-details-btn"
              onClick={() => {
                setProgramModelOpen(true);
              }}
            >
              View Details
              <img
                src={infoImg}
                alt="info"
                style={{ width: "14px", height: "14px" }}
              />
            </div>
          </div>
          <p className="video-page-content">
            {active === 0 ? jozuna_description : program_description}
          </p>
        </div>
        {programDropdownComponent && <div>{programDropdownComponent}</div>}
      </div>

      {assessmentFound && type === "Jozuna" ? (
        <div className="reco-assessment-not-found-container">
          <img
            src={AssessmentNotFound}
            alt="assessment not found"
            className="assessment-not-image"
          />
          <div className="assessment-not-image-text">
            Please take up an assessment to get a
            <br />
            <span className="assessment-not-image-text-span">
              personalized recommendation
            </span>
          </div>
        </div>
      ) : assessmentFound && type === "Industry" ? (
        <div className="reco-assessment-not-found-container">
          <img
            src={IndustryNotFound}
            alt="assessment not found"
            className="assessment-not-image"
          />
          <div className="assessment-not-image-text">
            No course has been assigned to this program
            <br />
          </div>
        </div>
      ) : (
        <CouresCardChildPage
          records={active === 0 ? cardData || [] : industry || []}
          industry_program_id={industry_program_id}
          program_description={program_description}
          program_title={program_title}
        />
        // <Container fluid className="h-100">
        //   <Row className="h-100" style={{ paddingTop: "10px" }}>
        //     <Col lg={4} className="left-column">
        //       <div className="videos-content-grid">
        //         {(active === 0 ? cardData || [] : industry || []).map(
        //           (data, index) => (
        //             <div key={index} style={{ width: "100%" }}>
        //               <div
        //                 onClick={() => {
        //                   if (!data.has_videos) return;
        //                   //Log the Course Event
        //                   logActionEvent(
        //                     analytics_strings.analytics_events.course_viewed,
        //                     {
        //                       candidate_id: userData.candidate_id,
        //                       course_name: data.course_title,
        //                     },
        //                   );
        //                   // if (active === 0) {
        //                   //   handleJozunaDataClick(data);
        //                   // } else {
        //                   //   handleIndustryDataClick(data);
        //                   // }
        //                   dispatch(setLRSelectedItem(null));
        //                   dispatch(setLRTopicDetailedIndex(null));
        //                   setSelectedItem(data);
        //                   dispatch(setLRCourseSelectedItem(data));
        //                 }}
        //                 // className={`learningroom-list-item ${
        //                 //   selectedItem?.course_id === data.course_id
        //                 //     ? "selected"
        //                 //     : ""
        //                 // } ${data.completion_status === "Completed" ? "completed" : ""} ${
        //                 //   !data.has_videos ? "disabled" : ""
        //                 // }`}
        //                 className={`learningroom-list-item ${
        //                   selectedItem?.course_id === data.course_id
        //                     ? "selected"
        //                     : data.completion_status === "Completed"
        //                       ? "completed"
        //                       : !data.has_videos
        //                         ? "disabled"
        //                         : "deselect"
        //                 }`}
        //               >
        //                 <div
        //                   style={{
        //                     display: "flex",
        //                     flexDirection: "column",
        //                     alignItems: "start",
        //                   }}
        //                 >
        //                   <div
        //                     style={{
        //                       display: "flex",
        //                       alignItems: "center",
        //                       gap: "10px",
        //                       justifyContent: "space-between",
        //                       width: "100%",
        //                       paddingRight: "15px",
        //                     }}
        //                   >
        //                     <p className={`status-badge`}>
        //                       {data.completion_status}
        //                     </p>
        //                     {data.is_new && (
        //                       <img
        //                         alt="Additional Icon"
        //                         src={NewIcon}
        //                         className="additionals-image"
        //                       />
        //                     )}
        //                   </div>
        //                   <div style={{ marginTop: "-30px" }}>
        //                     <CourseNameTitleTextComponent
        //                       title={data.course_title}
        //                     />
        //                   </div>
        //                   <div
        //                     style={{
        //                       display: "flex",
        //                       flexDirection: "row",
        //                       gap: "8px",
        //                       alignItems: "center",
        //                       justifyContent: "center",
        //                     }}
        //                   >
        //                     {/* <p
        //                       className="list-child"
        //                       style={{ fontSize: "0.8rem" }}
        //                     >
        //                       {data.total_videos}{" "}
        //                       {data.total_videos > 1 ? "videos" : "video"}
        //                       {" , "}
        //                       {data.total_files}{" "}
        //                       {data.total_files > 1 ? "Documents" : "Document"}
        //                     </p> */}
        //                   </div>
        //                   <div
        //                     className="view-details-btn"
        //                     onClick={(e) => {
        //                       e.stopPropagation();
        //                       setSelectedCourse(data);
        //                     }}
        //                   >
        //                     View Details
        //                     <img
        //                       src={infoImg}
        //                       alt="info"
        //                       style={{ width: "14px", height: "14px" }}
        //                     />
        //                   </div>

        //                   {/* <Button
        //                     className={`card-button ${
        //                       !data.has_videos ? "disabled" : ""
        //                     }`}
        //                     onClick={() => {
        //                       //Log the Course Event
        //                       logActionEvent(
        //                         analytics_strings.analytics_events
        //                           .course_viewed,
        //                         {
        //                           candidate_id: userData.candidate_id,
        //                           course_name: data.course_title,
        //                         },
        //                       );
        //                       if (active === 0) {
        //                         handleJozunaDataClick(data);
        //                       } else {
        //                         handleIndustryDataClick(data);
        //                       }
        //                     }}
        //                     disabled={!data.has_videos}
        //                   >
        //                     <img src={PlayButton} alt="play button" />
        //                     <span>{data.completion_status}</span>
        //                   </Button> */}
        //                 </div>
        //               </div>
        //             </div>
        //           ),
        //         )}
        //       </div>
        //     </Col>
        //     {selectedItem !== null && industry_program_id && (
        //       // program_title &&
        //       // program_description &&
        //       <LearningRoomViewPage
        //         course_id={selectedItem.course_id}
        //         course_name={selectedItem.course_title}
        //         program_id={industry_program_id}
        //         program_description={program_description}
        //         program_title={program_title}
        //       />
        //     )}
        //   </Row>
        // </Container>
      )}
      {/* <GenericModal
        isOpen={selectedCourse !== null}
        title="Course Information"
        onClose={() => {
          setSelectedCourse(null);
        }}
        width="60vh"
      >
        {selectedCourse?.course_thumbnail !== null &&
        selectedCourse?.course_thumbnail !== undefined ? (
          <img
            alt={selectedCourse.course_title ?? ""}
            src={selectedCourse?.course_thumbnail || "https://pick.com"}
            className="card-img"
            onError={(e) => handleImageErrorCallBack(e, "100%", "160px")}
          />
        ) : (
          <div className="no-thumbnail-placeholder">
            Thumbnail Image Missing
          </div>
        )}
        <CourseNameTitleTextComponent
          title={selectedCourse?.course_title ?? ""}
        />
        <CardText>{selectedCourse?.course_description}</CardText>
        <p className="list-child" style={{ fontSize: "0.8rem" }}>
          {selectedCourse?.total_videos}{" "}
          {(selectedCourse?.total_videos ?? 0) > 1 ? "videos" : "video"}
          {" , "}
          {selectedCourse?.total_files ?? 0}{" "}
          {(selectedCourse?.total_files ?? 0) > 1 ? "Documents" : "Document"}
        </p>
      </GenericModal> */}
      <GenericModal
        isOpen={programModelOpen}
        // title="Program Information"
        title={active === 0 ? (jozuna_title ?? "") : (program_title ?? "")}
        onClose={() => setProgramModelOpen(false)}
        // width="73vh"
        width="533px"
      >
        {/* <h1 className="video-page-heading">
          {active === 0 ? jozuna_title : program_title}
        </h1> */}
        <p className="video-page-content">
          {active === 0 ? jozuna_description : program_description}
        </p>
        <div className="info-prog">
          <div className="info-container-prog">
            <img src={Specialization} alt="specialization logo" />
            <div className="info-content">
              <h1 className="info-heading">Specialization:</h1>
              <p className="info-heading">
                {active === 0
                  ? `${cardData?.length || 0} Course Series`
                  : `${industry?.length || 0} Course Series`}
              </p>
            </div>
          </div>
          <div className="info-container-prog">
            <img src={Beginner} alt="Beginner logo" />
            <div className="info-content">
              <h1 className="info-heading">Beginner Level</h1>
              <p className="info-subheading">No prior experience required</p>
            </div>
          </div>
          <div className="info-container-prog">
            <img src={Content} alt="Content logo" />
            <div className="info-content">
              <h1 className="info-heading">
                {active === 0
                  ? `${jozunaDuration} Hours Content`
                  : `${industryDuration} Hours Content`}
              </h1>
            </div>
          </div>
          <div className="info-container-prog">
            <img src={Schedule} alt="Schedule logo" />
            <div className="info-content">
              <h1 className="info-heading">Flexible Schedule</h1>
              <p className="info-subheading">Learn at your own pace</p>
            </div>
          </div>
        </div>
      </GenericModal>
      <br />
    </div>
  );
};

export default CourseCardComponent;
